export default "__VITE_ASSET__C7P7niqR__"